// One function per backend endpoint (spec §4). Base URL, locale and Bearer token come from axios defaults.
import axios from 'axios';

const get = (url, params) => axios.get(url, { params }).then((r) => r.data);
const post = (url, body) => axios.post(url, body).then((r) => r.data);

// Locations / groups (module common)
export const getEnrichedLocations = () => get('/common/geo-locations/get-all-enriched');
export const getCustomPoints = () => get('/common/geo-locations/get-custom');
export const createPoint = (payload) => post('/common/geo-locations/create', payload);
export const updatePoint = (payload) => post('/common/geo-locations/update', payload);
export const deletePoint = (id) => post('/common/geo-locations/delete', { id });
export const getGroups = () => get('/common/geo-location-groups/get-all');
export const createGroup = (payload) => post('/common/geo-location-groups/create', payload);
export const updateGroup = (payload) => post('/common/geo-location-groups/update', payload);
export const deleteGroup = (id) => post('/common/geo-location-groups/delete', { id });

// Tasks (module tasktracker)
export const getActiveTasks = () => get('/tasktracker/tasks/get-by-status', { status_code: 'assigned' });
export const getTask = (id) => get('/tasktracker/tasks/get-one', { id });
export const createTaskDraft = () => post('/tasktracker/tasks/create', {});
export const confirmTask = (payload) => post('/tasktracker/tasks/confirm-create', payload);
export const rejectTaskDraft = (id) => post('/tasktracker/tasks/reject-create', { id });
export const updateTask = (payload) => post('/tasktracker/tasks/update', payload);
export const blockTask = (id) => post('/tasktracker/tasks/change-status', { id, status_code: 'blocked' });
export const getTasks = ({ created_from, created_to }) => get('/tasktracker/tasks/get-all', { created_from, created_to });
export const reopenTask = (id) => post('/tasktracker/tasks/change-status', { id, status_code: 'assigned' });

// Reference data
export const getFieldEngineers = () => get('/tasktracker/actors/get-field-engineers');
export const getWorkTypes = () => get('/tasktracker/work-types/get-all');

// Catalog («Справочник», KOP-37 spec §4)
export const getConsumables = () => get('/tasktracker/consumables/get-all');
export const getConsumablesIncludingArchived = () => get('/tasktracker/consumables/get-all-including-archived');
export const createConsumable = (payload) => post('/tasktracker/consumables/create', payload);
export const updateConsumable = (payload) => post('/tasktracker/consumables/update', payload);
export const archiveConsumable = (id) => post('/tasktracker/consumables/archive', { id });
export const unarchiveConsumable = (id) => post('/tasktracker/consumables/unarchive', { id });
export const getWorkTypesIncludingArchived = () => get('/tasktracker/work-types/get-all-including-archived');
export const createWorkType = (payload) => post('/tasktracker/work-types/create', payload);
export const updateWorkType = (payload) => post('/tasktracker/work-types/update', payload);
export const archiveWorkType = (id) => post('/tasktracker/work-types/archive', { id });
export const unarchiveWorkType = (id) => post('/tasktracker/work-types/unarchive', { id });

// Expenses («Расходы», KOP-39 spec §4)
export const getLocations = () => get('/common/geo-locations/get-all');
export const getLocationExpenses = ({ geo_location_id, date_from, date_to }) => get('/analytical/geo-location-all-expenses', { geo_location_id, date_from, date_to });
export const createLocationExpense = (payload) => post('/common/geo-location-expenses/create', payload);

// Field engineer («Трекер задач», KOP-40 spec §4.8)
export const getAssignedConsumables = () => get('/tasktracker/tasks/get-assigned-consumables');
export const getFieldWorksByTask = (task_id) => get('/tasktracker/field-works/get-by-task', { task_id });
export const setFieldWorkDone = ({ id, is_done }) => post('/tasktracker/field-works/set-done', { id, is_done });
export const completeTask = (payload) => post('/tasktracker/tasks/change-status', { ...payload, status_code: 'done' });
export const getCompletedTasks = ({ completed_from, completed_to }) => get('/tasktracker/tasks/get-completed', { completed_from, completed_to });
